import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import MillstageFilterBox from "../../../components/FilterBox/Millstage/MillstageFilter";
import { FiMenu } from "react-icons/fi";

import { Loader } from "../../../components/Loader/Loader";
import MillstageTable from "../../../components/Tables/MillstageTable";
import {
  LotWiseReport,
  LotWiseReportFun,
  StageFilters,
} from "../../../Redux/Slice/Millstage/MillstageSlice";
import { useTheme } from "../../../Themecontext/Themecontext";

export const LootWiseReport = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StageFiltersdata, LotWiseReportdata } = useSelector(
    (state) => state.MillstageSlice,
  );
  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWMILLSTAGE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWMILLSTAGEDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const [filter, setFilter] = useState({
    productionGroup: [],
  });

  const [search, setSearch] = useState({
    productionGroup: "",
  });
  const productionGroupList =
    StageFiltersdata?.ProdGrp?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  useEffect(() => {
    dispatch(StageFilters());
    dispatch(LotWiseReport({}));
  }, [dispatch]);

  // 🔷 Date

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      const updatedSelected = selected.includes(item.value)
        ? selected.filter((i) => i !== item.value)
        : [...selected, item.value];

      if (type === "productionGroup") {
        dispatch(LotWiseReportFun());

        dispatch(
          LotWiseReport({
            GroupIds: updatedSelected.join(","), // ✅ latest state
          }),
        );
      }

      return {
        ...prev,
        [type]: updatedSelected,
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  function formatToDDMMYYYY(date) {
    if (!date) return "";
    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const columns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "FromStage",
      key: "FromStage",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "ToStage",
      key: "ToStage",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "SrNo", key: "SrNo", align: "left" },
    { label: "Date", key: "Date", align: "left" },
    { label: "BatchNo", key: "BatchNo", align: "right" },
    { label: "Taka", key: "Taka", align: "right", format: "true" },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
  ];

  const rows = (LotWiseReportdata?.Data || []).map((row) => ({
    FromStage: row?.FromStage,
    ToStage: row?.ToStage,
    SrNo: row?.SrNo,
    Date: formatToDDMMYYYY(row?.Date),
    BatchNo: row?.BatchNo,
    Taka: row?.Taka,
    Meter: row?.Meter,
  }));

  if (!StageFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!LotWiseReportdata || LotWiseReportdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }
  return (
    <div
      style={{
        background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      <Row>
        {/* 🔷 Mobile Filter Button */}
        <Col xs={12} className=" d-lg-none mb-2 text-end ">
          <Button
            onClick={handleShow}
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              border: "none",
              borderRadius: "10px",
              padding: "8px 12px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
            }}
          >
            <FiMenu size={22} />
          </Button>
        </Col>

        {/* 🔷 Desktop Filter */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* Filters */}
            <MillstageFilterBox
              title="Production Group"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filter.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />
          </div>
        </Col>

        {/* 🔷 Offcanvas */}
        <Offcanvas show={showFilter} onHide={handleClose} placement="start"
          style={{
            background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
          }}
        >
          <Offcanvas.Header closeButton
            closeVariant={isdark === "dark" ? "white" : undefined}
            style={{ color: isdark === "light" ? "#000" : "#FFF", }}
          >
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <MillstageFilterBox
              title="Production Group"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filter.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />
          </Offcanvas.Body>
        </Offcanvas>

        {/* 🔷 Tables */}
        {/* 🔷 Table Section */}
        <Col xl={9} lg={8}>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              LOTWISE REPORT
            </div>

            <MillstageTable columns={columns} data={rows} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LootWiseReport;
